import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AmbientBackground } from "@/components/AmbientBackground";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col relative">
      <AmbientBackground />
      <div className="relative z-10 flex flex-col flex-1 min-h-screen">
        <Navbar />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
}
